
window.$ = require('jquery');
import ScrollReveal from 'scrollreveal';
import {TweenMax, Power2, TimelineMax} from "gsap/TweenMax";

$(document).ready(function () {

//  var $window = $(window);
//   $('.hero-section').each(function(){
//       var $bgobj = $(this);
//       $(window).on("scroll", function() {
//           var yPos = -($window.scrollTop() / -8);
//           var coords = '50% '+ yPos + 'px';
//           $bgobj.css({ backgroundPosition: coords });
//       });
//   });


  ScrollReveal().reveal($(".title:not(.fancypop .title)"), {
    desktop: true,
    opacity: null,
    beforeReveal: function (el) {
      function myFunction(){
        TweenMax.staggerFrom($(el).parents(".section").find(".animFade"), 0.5, {autoAlpha:0, y:10}, 0.2);
      }
      $(el).find(".title-line span");
      var tl = new TimelineMax({paused: true});
      tl.staggerFromTo($(el).find(".title-line span"), 0.3, {autoAlpha:0, y: 10},{autoAlpha:1, y: 0}, 0.1);
      tl.from($(el).find("h1,h2"), 0.3, {autoAlpha:0, y: 10}, "-=0.1");
      tl.call(myFunction, [], this, "-=0.2");
      tl.play();
    }
  });

ScrollReveal().reveal('.animContent', {
    duration: 1000,
    delay: 300,
    interval: 80
})


$("[data-scrollto]").on("click", function(e){
  e.preventDefault();
  var scrollToElm = $(this).data("scrollto");
  var scrollPos = $("#"+scrollToElm).offset().top - 75;
 $("html,body").stop().animate({scrollTop: scrollPos}, 1000);
 $(".hamburger.h-active").trigger("click");
});

$(".searchToggle").on("click", function(){
   $("body").toggleClass("search-active");
   setTimeout(function (){
    if($("body").hasClass("search-active")){
      $("#search")[0].focus();
    }
  }, 100);
});



  $(".hamburger").click(function(event) {
    $("body").toggleClass("menu-active");
  });

  $(".close-menu").on("click", function(){
    $("body").removeClass("menu-active");
  })


$(document).on("keyup", function(e){
  if(e.keyCode === 27){
    $(".fancybox-close-small").trigger("click");
    $("body").removeClass("search-active");
  }
});


var activeHeader = function() {
  var winPos = $(window).scrollTop();
  if (winPos > 0) {
    $(".header-main").addClass("header-active");
  } else {
    $(".header-main").removeClass("header-active");
  }
};
activeHeader();
$(window).scroll(function() {
  activeHeader();
});



});